import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import storeIcon from '../assets/icons/store.png';
import { components } from '../components';
import constants from '../helpers/constants';
import dateHelper from '../helpers/dateHelper';
import Enums from '../helpers/enums';
import utils from '../helpers/utils';
import { hooks } from '../hooks';
import ApiService from '../service/ApiService';
import { RootState } from '../store';

export const OrderSummary: React.FC = () => {
  const dispatch = hooks.useDispatch();
  const location = hooks.useLocation();
  const [opacity, setOpacity] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [orderSummary, setOrderSummary] = useState<any>({ orderDetails: {} });
  const [site, setSite] = useState({});
  const [deliveryDuration, setDeliveryDuration] = useState(0);
  const { orderId } = location.state || '';

  const allSites = useSelector((state: RootState) => state.screenReducer.sites);

  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor('#F6F9F9', '#F6F9F9', dispatch);

  useEffect(() => {
    getOrderDetails();
  }, []);

  useEffect(() => {
    if (orderSummary && orderSummary.orderDetail) {
      setSite(
        allSites.find((site) => site.siteId === orderSummary.orderDetail.siteId)
      );
    }
  }, [orderSummary]);

  // useEffect(() => {
  //   if (deliveryDuration > 0) {
  //     const setTimerInterval = setInterval(() => {
  //       setDeliveryDuration(deliveryDuration - 1);
  //     }, 60000);
  //     return () => clearInterval(setTimerInterval);
  //   }
  // }, [deliveryDuration]);

  const getOrderDetails = async () => {
    setLoading(true);
    const { data } = await ApiService.getOrderDetailsAsync(orderId);
    if (data) {
      setOrderSummary(data);
      //   const deliveryTime = dateUtils.getDeliveryDuration(data.orderDetail.createdDate, data.orderDetail.deliveryDuration);
      //   if (deliveryTime >= 0) {
      //     setDeliveryDuration(deliveryTime);
      //   }
    }
    setLoading(false);
  };

  // used only in ReOrder
  // const getFreeSaucesPrice = (item :any) => {
  //   let totalFreeItems = item.freeModifiers;
  //   let totalCustomizationPrice = 0;
  //   _.map(item.customizations, (selectedItem) => {
  //     if (totalFreeItems > 0 && selectedItem.setId === Enums.ModifiersSet.PacketSauce) {
  //       const freeQty = Math.min(totalFreeItems, selectedItem.quantity);
  //       const payableQty = selectedItem.quantity - freeQty;

  //       totalFreeItems -= freeQty;
  //       totalCustomizationPrice += (selectedItem.price * payableQty);
  //     } else {
  //       totalCustomizationPrice += (selectedItem.price * selectedItem.quantity);
  //     }

  //   });
  //   return totalCustomizationPrice;
  // };

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        title='Order Summary'
        showGoBack={true}
        isShowHome={true}
      />
    );
  };

  const Price = ({ item, isRedeemed }: any): JSX.Element => {
    if (item.isFree && item.itemPrice <= 0) {
      return <p className='t14'>Free</p>;
    } else if (isRedeemed) {
      return <p className='t14'>-</p>;
    }
    return <p className='t14'>{utils.formatCurrency(item.itemPrice)}</p>;
  };

  const renderCustomiseItems = (items: any) => {
    return items.map((customiseItem: any, index: number) => {
      return (
        <p className='t12' key={index} style={{ paddingLeft: 5, color: 'var(--text-color)' }}>
          {customiseItem.label}
        </p>
      );
    });
  };

  const renderComboItems = (items: any) => {
    return items.map((comboItem: any, index: number) => {
      return (
        <div key={index} style={{ paddingLeft: 5 }}>
          <p>{comboItem.itemName}</p>
          {comboItem.customizations &&
            renderCustomiseItems(comboItem.customizations)}
        </div>
      );
    });
  };

  const renderSummary = (): JSX.Element => {
    const isRedeemed =
      orderSummary?.paymentDetail?.brand.indexOf('Redeemed') >= 0;

    const numberofItems =
      orderSummary.orderItems.items.length +
      orderSummary.orderItems.combos.length;
    return (
      <>
        <div
          style={{
            background: 'var(--white-color)',
            gap: '8px',
            marginTop: '12px',
            marginBottom: '12px',
            border: 'var(--white-color)',
            borderRadius: '12px',
            padding: '20px',
            cursor: 'pointer',
            transition: 'background 0.2s ease, border 0.2s ease',
          }}
        >
          <section
            style={{
              paddingBottom: 5,
              borderBottom: '1px solid var(--border-color)',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <div className='t14'>
                <h4 className='h4' style={{ marginBottom: 8 }}>
                  Order Ref# {orderSummary.orderDetail.refOrderId}
                </h4>
                <p style={{ marginBottom: 8 }}>
                  Order placed at{' '}
                  {dateHelper.displayDatetime(
                    orderSummary.orderDetail.createdDate
                  )}{' '}
                  |{numberofItems === 1 ? ' 1 Item' : ` ${numberofItems} Items`}{' '}
                </p>
                {orderSummary?.paymentDetail && (
                  <p style={{ marginBottom: 8 }}>
                    Paid By - {orderSummary.paymentDetail?.brand}{' '}
                    {orderSummary.paymentDetail.lastFourDigits
                      ? `**** **** **** ${orderSummary.paymentDetail.lastFourDigits}`
                      : ''}
                  </p>
                )}
                {orderSummary.orderDetail.payType && (
                  <p style={{ marginBottom: 8 }}>
                    Payment Mode -{' '}
                    {
                      Enums.payType[
                      orderSummary.orderDetail
                        .payType as keyof typeof Enums.payType
                      ]
                    }
                  </p>
                )}
                {orderSummary?.refundDetail && (
                  <p style={{ marginBottom: 8 }}>
                    Refunded{' '}
                    {utils.formatCurrency(
                      orderSummary.refundDetail.refundAmount
                    )}{' '}
                    at{' '}
                    {dateHelper.displayDatetime(
                      orderSummary.refundDetail.createdDate
                    )}
                  </p>
                )}
              </div>
            </div>
          </section>
          <section
            style={{
              marginBottom: 10,
              borderBottom: '1px solid var(--border-color)',
            }}
          >
            {orderSummary.orderItems.items.map(
              (subItem: any, index: number) => {
                const itemName =
                  subItem.type === Enums.comboType.menuItem
                    ? subItem.name
                    : subItem.comboName;
                return (
                  <div
                    key={index}
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr auto',
                      alignItems: 'start',
                      paddingTop: 10,
                      paddingBottom: 10,
                      gap: '10px',
                    }}
                  >
                    <div style={{ wordBreak: 'break-word' }} className='t14'>
                      <span>{subItem.quantity} X </span>
                      <span style={{ flexShrink: 1 }}>{itemName}</span>
                      {subItem.optionSetItemName && (
                        <div className='t14' style={{ paddingTop: 2 }}>
                          ({subItem.optionSetItemName})
                        </div>
                      )}
                      {subItem.customizations &&
                        renderCustomiseItems(subItem.customizations)}
                    </div>
                    <div style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                      <Price
                        key={index}
                        item={subItem}
                        isRedeemed={isRedeemed}
                      />
                    </div>
                  </div>
                );
              }
            )}
            {orderSummary.orderItems.combos.map((item: any, index: number) => {
              return (
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr auto',
                    alignItems: 'start',
                    paddingTop: 10,
                    paddingBottom: 10,
                    gap: '10px',
                  }}
                >
                  <div
                    style={{
                      flexWrap: 'wrap',
                      flex: 1,
                    }}
                    className='t14'
                  >
                    <span>{item.quantity} X </span>
                    <span style={{ flexShrink: 1 }}>{item.name}</span>
                    {renderComboItems(item.items)}
                  </div>
                  <div style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                    <Price key={index} item={item} isRedeemed={isRedeemed} />
                  </div>
                </div>
              );
            })}
          </section>
          {!isRedeemed && (
            <section
              style={{
                marginBottom: 10,
                borderBottom: '1px solid var(--border-color)',
                paddingRight: 10,
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  marginBottom: 10,
                }}
                className='t14'
              >
                <div>
                  {orderSummary.orderDetail.orderMode ===
                    Enums.orderMode.Delivery && <p>Delivery Fees</p>}
                  <p style={{ marginBottom: 8 }}>Discount</p>
                  <p style={{ marginBottom: 8 }}>GST included</p>
                </div>
                <div>
                  {orderSummary.orderDetail.orderMode ===
                    Enums.orderMode.Delivery && (
                      <p style={{ marginBottom: 8 }}>
                        {utils.formatCurrency(
                          orderSummary.orderDetail.deliveryCharges
                        )}
                      </p>
                    )}
                  <p style={{ marginBottom: 8 }}> - </p>
                  <p style={{ marginBottom: 8 }}>
                    {utils.formatCurrency(orderSummary.orderDetail.tax)}
                  </p>
                </div>
              </div>
            </section>)}
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              paddingRight: 10,
            }}
            className='t16'
          >
            <p style={{ fontWeight: 700 }}>Total</p>
            <p style={{ fontWeight: 700 }}>
              {utils.formatCurrency(orderSummary.orderDetail.orderAmount)}
            </p>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          ></div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            padding: 5,
            justifyContent: 'space-between',
          }}
        >
          {/* <div>
            <components.Button
              text='RE ORDER'
              containerStyle={{
                paddingLeft: 10,
                paddingRight: 10,
                height: 40,
              }}
              onClick={handleOnDelete}
            />
          </div>
          <div>
            <components.Button
              text='RATE YOUR ORDER'
              containerStyle={{
                paddingLeft: 10,
                paddingRight: 10,
                height: 40,
                background: 'none',
                color: 'var(--text-color)',
                border: 'none',
              }}
            />
          </div> */}
        </div>
      </>
    );
  };

  const renderSite = (): JSX.Element => {
    let address;
    if (site) {
      address = utils.formatAddress(site);
    }
    return (
      <>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 8,
            marginTop: 10
          }}
        >
          <div>
            <p style={{ marginTop: 2, fontWeight: 700 }} className='t18'>
              <span style={{ paddingRight: 5 }}>Order</span>
              {`#${orderSummary.orderDetail.orderNo}`}
            </p>
          </div>
          {/* {
            orderSummary.orderDetail.status !== Enums.orderStatus.FULFILLED &&
              orderSummary.orderDetail.orderMode === Enums.orderMode.Delivery
              && deliveryDuration >= 0
              ?
              <CjRoundedView
                iconName='truck-fast-outline'
                backgroundColor={theme.colors.onPrimary}
                border={theme.colors.primary}
                iconSize={20}
                iconColor={theme.colors.primary}
                textColor={theme.colors.primary}
                title={deliveryDuration > 0 ? `Delivering in ${deliveryDuration} mins` : 'Fulfilled'} />
              :
              <CjSurface margin={[0, 0, 0, 0]} style={[CjStyles(theme).chip,
              { backgroundColor: orderSummary.orderDetail.color }]}>
                <Text variant='labelMedium' style={{ color: theme.colors.onPrimary }}>{orderSummary.orderDetail.statusName}</Text>
              </CjSurface>
          } */}
          <div>
            <components.Button
              text={orderSummary.orderDetail.statusName}
              containerStyle={{
                height: '28px',
                padding: '10px',
                background: 'var(--button-color)',
                border: 'none',
                borderRadius: 8,
                fontWeight: 400,
              }}
            ></components.Button>
          </div>
        </div>
        <section
          style={{
            padding: 20,
            borderRadius: 10,
            backgroundColor: 'var(--white-color)',
          }}
          className='row-center-space-between clickable'
        >
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span
              className='t16 number-of-lines-1'
              style={{
                fontWeight: 500,
                marginBottom: 8,
                color: 'var(--main-color)',
                textTransform: 'capitalize',
              }}
            >
              {orderSummary.orderDetail && orderSummary.orderDetail.siteName}
            </span>
            {address && (
              <span className='t12 number-of-lines-1'>
                {address.line1 + address.line2}
              </span>
            )}
          </div>
        </section>
        <section
          style={{
            padding: 20,
            borderRadius: 10,
            backgroundColor: 'var(--white-color)',
            marginTop: 10,
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <div
            style={{
              flex: '0 0 60px',
              height: '50px',
              width: '50px',
              background: '#f4f4f4',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '22px',
              marginRight: '16px',
            }}
          >
            <img
              src={storeIcon}
              alt={'store-icon'}
              style={{
                width: 20,
                fill: 'var(--white-color)',
                background: 'var(--white-color)',
                height: 20,
                objectFit: 'contain',
              }}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span
              className='t16 number-of-lines-1'
              style={{
                fontWeight: 500,
                marginBottom: 8,
                color: 'var(--main-color)',
                textTransform: 'capitalize',
              }}
            >
              Order{' '}
              {
                constants.orderModeDisplay[
                orderSummary.orderDetail
                  .orderMode as keyof typeof constants.orderModeDisplay
                ]
              }{' '}
              at{' '}
              {dateHelper.displayTime(orderSummary.orderDetail.promiseDateTime)}
            </span>
            {orderSummary.orderDetail.orderMode === Enums.orderMode.Delivery ? (
              <p className='t14'>
                Pick up {utils.formatSiteName(site)} at{' '}
                {dateHelper.displayTime(orderSummary.orderDetail.pickupTime)}
              </p>
            ) : (
              <p className='t14'>{utils.formatSiteName(site)}</p>
            )}
            {/* {orderSummary.orderRatingDetail && (
              <CjRatingContainer
                imageSize={20}
                readonly
                startingValue={orderSummary.orderRatingDetail.rating}
              />
            )} */}
          </div>
        </section>
      </>
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <main className='scrollable container'>
        {orderSummary.orderDetail && renderSite()}
        {orderSummary.orderDetail && renderSummary()}
      </main>
    );
  };

  const renderLoader = (): JSX.Element | null => {
    if (!loading) return null;
    return (
      <div
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(0,0,0,0.25)',
          zIndex: 9999,
          display: 'grid',
          placeItems: 'center',
        }}
      >
        <components.Loader />
      </div>
    );
  };

  return (
    <div id='screen' style={{ opacity }}>
      {renderLoader()}
      {renderHeader()}
      {renderContent()}
    </div>
  );
};
